module.exports = __webpack_public_path__ + "static/media/reserve.2a15bb05.svg";